require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-team-carla-garcia-zendejas.json") })
        }
      }, "path---en-us-team-carla-garcia-zendejas");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-team-carla-garcia-zendejas!./.cache/json/en-us-team-carla-garcia-zendejas.json
// module id = 588
// module chunks = 231608221292675